import LoginController from './login.controller';

export default {
    template: require('./login.form.html'),
    controller: LoginController
};
